import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/libraries/globals';
import { Sessions } from 'src/app/libraries/sessions';
import { ServiciosTiposService } from 'src/app/services/serviciosTipos/serviciosTipos.service';
import { Dialogs } from 'src/app/ui/dialogs/dialogs';
import { Wait } from 'src/app/ui/wait/Wait';
import { ServiciosTiposIndexEditComponent } from './edit/edit.component';

@Component({
  selector: 'comp-servicios-tipos-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class ServiciosTiposIndexComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false})    paginator       : MatPaginator;
  @ViewChild('tableContainer', {static: false}) tableContainer  : ElementRef;

  private lstServiciosTipos : Array<any> = [];
  private objDialogs        : Dialogs = new Dialogs();
  private index             : number;

  // SEARCH
  private txtSearch = new FormControl();

  // COLUMNS
  columns: string[] = ['index', 'opciones', 'clave', 'name', 'descripcion', 'precioUnitario', 'createdAspNetUser', 'createdFecha', 'updatedAspNetUser', 'updatedFecha'];

  // SEARCH FILTERS
  searchFilters : Array<any> = [{field : 'clave'}, {field : 'name'}, {field : 'descripcion'}];
  
  dataSource : MatTableDataSource<any>;

  private objPrivilegies : any;

  constructor(private objServiciosTiposService : ServiciosTiposService,
              private dialog: MatDialog,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.objPrivilegies = Sessions.getItem('privilegies');
    this.dataSource = new MatTableDataSource<any>();
  }

  ngAfterViewInit() {
    this.build();
  }

  // EVENTOS
  btnEdit_clickEvent(element : any) {
    
    const dialogRef = this.dialog.open(ServiciosTiposIndexEditComponent, {
      width     : '99%',
      height    : '99%',
      maxWidth  : '400px',
      maxHeight : '350px'
    });

    dialogRef.componentInstance.objData = element;

    dialogRef.componentInstance.onChange.subscribe(() => {
      this.build();
    });

  }

  btnDelete_clickEvent(element : any) {
    
    this.objDialogs.Confirm("Eliminar", "¿Eliminar servicio "+ element.name +"?", "Eliminar", "Cancelar", ()=> {
      this.delete(element.idServicioTipo);
    });

  }

  // METODOS
  private build() : void {

    let varArgs : any = {
      search              : Globals.validValue(this.txtSearch.value) ? this.txtSearch.value : "",
      searchFilters       : this.searchFilters,
      filters             : [],
      dateFrom            : "",
      dateTo              : "",
      dateOptions         : [{field : "CreatedFecha"}],
      columns             : [],
      persistenceColumns  : [],
      length              : !Globals.validValue(this.paginator.pageSize) ? 15 : this.paginator.pageSize,
      page                : this.paginator.pageIndex + 1
    };

    Wait.show(this.tableContainer, "Cargando datos...");

    this.objServiciosTiposService.dataSource(varArgs)
    .subscribe( objResponse => {

      if(objResponse.session) {

        if(objResponse.action) {

          this.lstServiciosTipos    = objResponse.result.rows;

          this.dataSource           = new MatTableDataSource(this.lstServiciosTipos);
          this.paginator.pageIndex  = objResponse.result.page - 1;
          this.paginator.pageSize   = objResponse.result.length;
          this.paginator.length     = objResponse.result.count;
          this.index                = this.paginator.pageIndex * this.paginator.pageSize + 1;

        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }

      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }
      
      Wait.hide(this.tableContainer);
      
    }, error => {
      Wait.hide(this.tableContainer);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });
    
  }

  private borrarFiltros() : void {
    this.txtSearch.setValue("");
    this.build();
  }

  private delete(idServicioTipo : any) : void {
    
    Wait.show(this.tableContainer, "Eliminando...")

    let objServicioTipoDelete : any =
    {
      idServicioTipo : idServicioTipo
    };

    this.objServiciosTiposService.delete(objServicioTipoDelete)
    .subscribe( objResponse => {
    
      if(objResponse.session) {

        if(objResponse.action) {
          
          this.build();
          this.objDialogs.Success(objResponse.title, objResponse.message);
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      Wait.hide(this.tableContainer);

    }, error => {

      Wait.hide(this.tableContainer);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });
  }

}
